import { useCallback, useState } from "react"

interface LayoutStateResult {
  notificationsOpen: boolean
  searchOpen: boolean
  createOpen: boolean
  shareOpen: boolean
  sidebarOpen: boolean
  reportModalOpen: boolean
  reportUserId: string | null
  reportCommunityModalOpen: boolean
  reportRitualModalOpen: boolean
  handleSearchOpen: (open: boolean) => void
  handleNotificationsOpen: (open: boolean) => void
  handleCreateOpen: (open: boolean) => void
  setShareOpen: (open: boolean) => void
  setSidebarOpen: (open: boolean) => void
  setReportModalOpen: (open: boolean) => void
  setReportUserId: (id: string | null) => void
  setReportCommunityModalOpen: (open: boolean) => void
  setReportRitualModalOpen: (open: boolean) => void
}

export function useLayoutState(): LayoutStateResult {
  const [notificationsOpen, setNotificationsOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const [createOpen, setCreateOpen] = useState(false)
  const [shareOpen, setShareOpen] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [reportModalOpen, setReportModalOpen] = useState(false)
  const [reportUserId, setReportUserId] = useState<string | null>(null)
  const [reportCommunityModalOpen, setReportCommunityModalOpen] = useState(false)
  const [reportRitualModalOpen, setReportRitualModalOpen] = useState(false)

  const handleSearchOpen = useCallback((open: boolean) => {
    if (open) {
      setNotificationsOpen(false)
      setCreateOpen(false)
    }
    setSearchOpen(open)
  }, [])

  const handleNotificationsOpen = useCallback((open: boolean) => {
    if (open) {
      setSearchOpen(false)
      setCreateOpen(false)
    }
    setNotificationsOpen(open)
  }, [])

  const handleCreateOpen = useCallback((open: boolean) => {
    if (open) {
      setSearchOpen(false)
      setNotificationsOpen(false)
    }
    setCreateOpen(open)
  }, [])

  return {
    notificationsOpen,
    searchOpen,
    createOpen,
    shareOpen,
    sidebarOpen,
    reportModalOpen,
    reportUserId,
    reportCommunityModalOpen,
    reportRitualModalOpen,
    handleSearchOpen,
    handleNotificationsOpen,
    handleCreateOpen,
    setShareOpen,
    setSidebarOpen,
    setReportModalOpen,
    setReportUserId,
    setReportCommunityModalOpen,
    setReportRitualModalOpen,
  }
}
